import { render, staticRenderFns } from "./referral-registration-field.vue?vue&type=template&id=463c7185&"
import script from "./referral-registration-field.vue?vue&type=script&lang=ts&"
export * from "./referral-registration-field.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_wzvh6gi4tchptuexh7cjhim74e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports